import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { ProjetoProdutoService } from '../services/projeto-produto.service';

@Injectable({
  providedIn: 'root',
})
export class ProjetoProdutoResolver implements Resolve<boolean> {
  constructor(private service: ProjetoProdutoService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}

@Injectable({
  providedIn: 'root',
})
export class ProjetoProdutoFiltersResolver implements Resolve<boolean> {
  constructor(private service: ProjetoProdutoService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getFilters();
  }
}
